var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", { ref: "formValidator" }, [
    _c(
      "div",
      { staticClass: "specialist-tab-content" },
      [
        _c("div", { staticClass: "row p-1 mb-4" }, [
          _c(
            "div",
            { staticClass: "col-sm" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          attrs: {
                            "custom-error-msg": _vm.errorMsgs.firstName,
                            disabled: _vm.disabled,
                            error: errors[0],
                            label: "Nombre:"
                          },
                          model: {
                            value: _vm.specialistData.firstName,
                            callback: function($$v) {
                              _vm.$set(_vm.specialistData, "firstName", $$v)
                            },
                            expression: "specialistData.firstName"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm" },
            [
              _c("custom-input", {
                attrs: { disabled: _vm.disabled, label: "Segundo Nombre:" },
                model: {
                  value: _vm.specialistData.middleName,
                  callback: function($$v) {
                    _vm.$set(_vm.specialistData, "middleName", $$v)
                  },
                  expression: "specialistData.middleName"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          attrs: {
                            "custom-error-msg": _vm.errorMsgs.lastPaternalName,
                            disabled: _vm.disabled,
                            error: errors[0],
                            label: "Apellido Paterno:"
                          },
                          model: {
                            value: _vm.specialistData.lastPaternalName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.specialistData,
                                "lastPaternalName",
                                $$v
                              )
                            },
                            expression: "specialistData.lastPaternalName"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm" },
            [
              _c("custom-input", {
                attrs: { disabled: _vm.disabled, label: "Apellido Materno:" },
                model: {
                  value: _vm.specialistData.lastMaternalName,
                  callback: function($$v) {
                    _vm.$set(_vm.specialistData, "lastMaternalName", $$v)
                  },
                  expression: "specialistData.lastMaternalName"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          attrs: {
                            "custom-error-msg": _vm.errorMsgs.email,
                            disabled: !_vm.userHasPermissions(
                              "provider.specialist.email.update"
                            ),
                            error: errors[0],
                            label: "Correo Electrónico:"
                          },
                          model: {
                            value: _vm.specialistData.email,
                            callback: function($$v) {
                              _vm.$set(_vm.specialistData, "email", $$v)
                            },
                            expression: "specialistData.email"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          this.isEducationDepartment() && !_vm.specialistData.isCseeOfficial
            ? _c(
                "div",
                { staticClass: "col-sm" },
                [
                  _c("custom-input", {
                    attrs: {
                      disabled: _vm.disabled,
                      label: "Número de KRONO:"
                    },
                    model: {
                      value: _vm.specialistData.staffId,
                      callback: function($$v) {
                        _vm.$set(_vm.specialistData, "staffId", $$v)
                      },
                      expression: "specialistData.staffId"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _c("div", { staticClass: "row p-1 mb-4" }, [
          _c(
            "div",
            { staticClass: "col-sm" },
            [
              _c("custom-input", {
                attrs: {
                  disabled: true,
                  label: "SSN:",
                  value: _vm.maskSSN(_vm.specialistData.socialSecurityNumber)
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-sm" },
            [
              _c("validation-provider", {
                attrs: { rules: _vm.isHealthDeptNoEnabled ? "max:16" : "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          attrs: {
                            "custom-error-msg":
                              "El campo no debe ser mayor a 16 caracteres",
                            disabled: !_vm.isHealthDeptNoEnabled,
                            error: errors[0],
                            "error-class": "position-absolute",
                            label: "Número de Registro de Salud:"
                          },
                          model: {
                            value: _vm.specialistData.registrationNumber,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.specialistData,
                                "registrationNumber",
                                $$v
                              )
                            },
                            expression: "specialistData.registrationNumber"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.isMedicaidDocumentationWorkflowEnabled
            ? _c(
                "div",
                { staticClass: "col-sm" },
                [
                  _c("custom-input", {
                    attrs: {
                      disabled: _vm.disabled,
                      label: "Identificador Nacional del Especialista:"
                    },
                    model: {
                      value: _vm.specialistData.nationalIdentifier,
                      callback: function($$v) {
                        _vm.$set(_vm.specialistData, "nationalIdentifier", $$v)
                      },
                      expression: "specialistData.nationalIdentifier"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isMedicaidDocumentationWorkflowEnabled
            ? _c(
                "div",
                { staticClass: "col-sm" },
                [
                  _c("custom-date-picker", {
                    attrs: {
                      "class-container": "w-100",
                      format: "dd/MMM./yyyy",
                      label: "Fecha de Vencimiento Medicaid:",
                      "min-date": _vm.currentDate
                    },
                    model: {
                      value: _vm.specialistData.medicaidDueDate,
                      callback: function($$v) {
                        _vm.$set(_vm.specialistData, "medicaidDueDate", $$v)
                      },
                      expression: "specialistData.medicaidDueDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "col-sm" }, [
            _c(
              "div",
              { staticClass: "mt-4 text-right" },
              [
                _vm.immediateSave && !_vm.disabled
                  ? _c("ActionButton", {
                      attrs: {
                        i: "fas fa-save",
                        text: "Actualizar",
                        variant: "success"
                      },
                      on: { click: _vm.updateSpecialistNames }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _vm.userHasPermissions("specialist.AtEvaluator.assign")
          ? _c("div", [
              _c(
                "div",
                { staticClass: "row align-items-center" },
                [
                  _c(
                    "span",
                    { staticClass: "font-weight-normal font-16 ml-3 mr-auto" },
                    [
                      _vm._v(
                        " ¿El especialista es evaluador de Asistencia Tecnológica? "
                      )
                    ]
                  ),
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-radio", {
                                ref: "question",
                                staticClass: "custom-radio__extended p-0 mr-5",
                                attrs: {
                                  "container-class": "custom-radio-center",
                                  "custom-error-msg": "Marque sí o no.",
                                  disabled:
                                    _vm.disabled || _vm.haveCertifiedATLicense,
                                  error: Boolean(errors[0]),
                                  "is-question-list": "",
                                  name: "question-1",
                                  options: _vm.questionOptions
                                },
                                model: {
                                  value: _vm.questionAnswer,
                                  callback: function($$v) {
                                    _vm.questionAnswer = $$v
                                  },
                                  expression: "questionAnswer"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2279106612
                    )
                  })
                ],
                1
              ),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", {
                    staticClass: "dropdown-divider mt-0 pb-2 w-100 line"
                  })
                ])
              ])
            ])
          : _vm._e(),
        _c("validation-provider", {
          attrs: { rules: "required" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function({ errors }) {
                return [
                  _c("license-information-list", {
                    ref: "licInformationList",
                    attrs: {
                      "add-enabled":
                        _vm.userHasPermissions(
                          "provider.specialist.license.add"
                        ) && !_vm.disabled,
                      "delete-enabled":
                        _vm.userHasPermissions(
                          "provider.specialist.license.delete"
                        ) &&
                        (_vm.specialist.id == null || _vm.specialist.id <= 0) &&
                        !_vm.disabled,
                      "edit-enabled":
                        _vm.userHasPermissions(
                          "provider.specialist.license.edit"
                        ) && !_vm.disabled,
                      "immediate-save": _vm.immediateSave,
                      "is-a-t-evaluator": _vm.questionAnswer,
                      "is-csee-official": _vm.specialistData.isCseeOfficial,
                      "is-related-master": _vm.specialistData.isRelatedToMaster,
                      "specialist-company-id": _vm.specialistCompanyId,
                      "specialist-id":
                        _vm.specialist.id == null ? 0 : _vm.specialist.id,
                      "specialist-license-document-types":
                        _vm.specialistLicenseDocumentTypes
                    },
                    on: {
                      "on-license-change": _vm.emitSpecialistChange,
                      "on-opened": _vm.onLicenseOpened
                    },
                    model: {
                      value: _vm.specialistData.licenses,
                      callback: function($$v) {
                        _vm.$set(_vm.specialistData, "licenses", $$v)
                      },
                      expression: "specialistData.licenses"
                    }
                  }),
                  errors[0]
                    ? _c("error", {
                        attrs: {
                          message: _vm.errorMsgs.license,
                          variant: "no-border"
                        }
                      })
                    : _vm._e()
                ]
              }
            }
          ])
        }),
        _c("validation-provider", {
          attrs: { rules: "required" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function({ errors }) {
                return [
                  _c("service-place-information-list", {
                    ref: "spInformationList",
                    attrs: {
                      "add-enabled": _vm.userHasPermissions(
                        "provider.specialist.serviceplace.add"
                      ),
                      "can-add-locations": _vm.canAddLocations,
                      "delete-enabled": _vm.userHasPermissions(
                        "provider.specialist.serviceplace.delete"
                      ),
                      "edit-enabled": _vm.userHasPermissions(
                        "provider.specialist.serviceplace.edit"
                      ),
                      "immediate-save": _vm.immediateSave,
                      "self-assign": _vm.selfAssign(),
                      specialist: _vm.specialistData,
                      "specialist-id":
                        _vm.specialist.id == null ? 0 : _vm.specialist.id
                    },
                    on: {
                      "finish-add-location": _vm.saveExemptionFiles,
                      "init-add-locations": function($event) {
                        _vm.showExemptionError = true
                      },
                      "on-location-change": _vm.emitSpecialistChange,
                      "on-opened": _vm.onLocationOpened
                    },
                    model: {
                      value: _vm.specialistData.locations,
                      callback: function($$v) {
                        _vm.$set(_vm.specialistData, "locations", $$v)
                      },
                      expression: "specialistData.locations"
                    }
                  }),
                  errors[0]
                    ? _c("error", {
                        attrs: {
                          message: _vm.errorMsgs.servicePlaceInformation,
                          variant: "no-border"
                        }
                      })
                    : _vm._e()
                ]
              }
            }
          ])
        }),
        _vm.isExemptionRequired && _vm.isExemptionParamEnabled
          ? _c(
              "div",
              [
                _c("section-title", {
                  staticStyle: { "margin-top": "40px" },
                  attrs: { content: "Documentos de Dispensa", "has-line": true }
                }),
                _vm._l(_vm.innerExemptionFiles, function(exemptionFile, i) {
                  return _c(
                    "div",
                    { key: i },
                    [
                      _c(
                        "callout",
                        {
                          attrs: {
                            "class-main": "mb-2 py-3",
                            "has-toggle": false
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex justify-content-between"
                            },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  { staticClass: "exemption-file__title" },
                                  [_vm._v("Documento")]
                                ),
                                _c("p", [_vm._v(_vm._s(exemptionFile.name))])
                              ]),
                              _c(
                                "div",
                                [
                                  _c("CustomFileInput", {
                                    attrs: {
                                      accept: ".pdf",
                                      "add-text":
                                        "Presione aquí para añadir Documento",
                                      "attachment-id": exemptionFile.fileId,
                                      "can-delete": !_vm.hasUploadedExemptionFiles,
                                      disabled: _vm.hasUploadedExemptionFiles,
                                      "display-style": "normal",
                                      name: exemptionFile.fileName,
                                      "on-download": () => {}
                                    },
                                    model: {
                                      value: exemptionFile.file,
                                      callback: function($$v) {
                                        _vm.$set(exemptionFile, "file", $$v)
                                      },
                                      expression: "exemptionFile.file"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      ),
                      _vm.showExemptionError &&
                      exemptionFile.required &&
                      !exemptionFile.file &&
                      !exemptionFile.fileId
                        ? _c("error", {
                            staticClass: "mb-3",
                            attrs: {
                              message: "El documento es requerido.",
                              variant: "no-border"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                })
              ],
              2
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }